import AxiosJob from '@/services/api/job/axios_job'

  export default {
  /**
   * Prepare folder structure and create/get markup session
   * @param {Object} data - { job_id, format_instance_id, markup_session_name, markup_session_id }
   * @returns {Promise} - { markup_session_id, node_id }
   */
  prepareStructure(data) {
    return AxiosJob.post(`/job/deliverable/asset/prepare-structure`, data)
  },

  /**
   * Link uploaded asset to markup session
   * @param {Object} data - { job_id, format_instance_id, node_id, markup_session_id, version }
   * @returns {Promise}
   */
  linkAsset(data) {
    return AxiosJob.post(`/job/deliverable/asset/link`, data)
  },

  associateAssets(jobId, data) {
    return AxiosJob.post(`/job/associate-assets/${jobId}`, data)
  },

  /**
   * Get all assets for a format instance
   * @param {Number|String} formatInstanceId
   * @returns {Promise}
   */
  getAssets(formatInstanceId) {
    return AxiosJob.get(`/job/deliverable/asset/format-instance/${formatInstanceId}`)
  },

  readAssets(jobDeliverId, jobId, params = {}) {
    return AxiosJob.get(`/deliverable/assets-read/${jobDeliverId}/job/${jobId}`, { params })
  },

  /**
   * Update asset status (approve/reject)
   * @param {Number|String} assetId
   * @param {Number|String} jobId Job or subtask being operated on
   * @param {Object} data - { status, notes }
   * @returns {Promise}
   */
  updateStatus(assetId, data) {
    return AxiosJob.patch(`/job/deliverable/asset/${assetId}/status`, data)
  },

  /**
   * Delete an asset
   * @param {Number|String} assetId
   * @returns {Promise}
   */
  delete(assetId, jobId) {
    return AxiosJob.delete(`/job/deliver/asset/${assetId}`, { params: { job_id: jobId } })
  }
}
